import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

import { KNBR_RETURN_ORDER_SEARCH, KN_BR_CUSTOMER_CURRENT } from '../../../../constants/api.endpoints.constant';
import { KnBrCustomerContextService } from '../../../../store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrReturnOrderSearchForm } from 'src/feature-libs/kn-br-order/root/models/kn-br-order.model';

@Injectable({
  providedIn: 'root',
})
export class KnBrOrderReturnAdapter {
  customerNumber: string;
  constructor(
    private endPointService: OccEndpointsService,
    private httpClient: HttpClient,
    protected knBrCustomerContextService: KnBrCustomerContextService
  ) {
    this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
      this.customerNumber = response ? response : null;
    });
  }

  retrunOrdersSearch(returnOrderSearch: KnBrReturnOrderSearchForm) {
    const CUSTOMER_NUMBER = this.customerNumber ? this.customerNumber : KN_BR_CUSTOMER_CURRENT;
    return this.httpClient.get(
      this.endPointService.buildUrl(KNBR_RETURN_ORDER_SEARCH, {
        urlParams: {
          customerId: CUSTOMER_NUMBER,
        },
        queryParams: returnOrderSearch,
      })
    );
  }
}
